import React from 'react'
import ContactForm from '../../components/contactform/ContactForm'
import PageHeader from '../../components/headers/PageHeader'
import castel from "../../assets/Images/castel.jpg"
import './Contactus.css'

export default function Contactus() {
    return (
        <div className="contact-page">
            <PageHeader
                mediaSrc={castel}
                mediaType={"image"}
                title={"Contact Us"}
                slogan={
                    "If you would like any further information about any of our software or services please complete the form below."
                }
            />

            <section className="contact-formSection">
                <ContactForm />
            </section>

            <section className="contact-addressSection">
                <h2>Our Offices</h2>

                <div className="contact-addressGrid">

                    {/* USA - New Jersey */}
                    <article className="contact-addressCard">
                        <span className="contact-officeBadge">
                            United States
                        </span>

                        <h3>Eupraxia Life Sciences LLC</h3>

                        <p>
                            3000 Hadley Road, 3rd Floor<br />
                            Office 233<br />
                            South Plainfield, NJ 07080<br />
                            United States
                        </p>
                    </article>

                    {/* India - Vadodara */}
                    <article className="contact-addressCard">
                        <span className="contact-officeBadge">
                            India
                        </span>

                        <h3>
                            Eupraxia Centre for Clinical Excellence LLP
                        </h3>

                        <p>
                            204-209, Sarathi Complex<br />
                            Opp: Nutan Bharat Club, Alkapuri<br />
                            Vadodara, Gujarat - 390007<br />
                            India
                        </p>
                    </article>

                    {/* India - Bengaluru */}
                    <article className="contact-addressCard">
                        <span className="contact-officeBadge">
                            India
                        </span>

                        <h3>
                            Eupraxia Centre for Clinical Excellence LLP
                        </h3>

                        <p>
                            No.18, 3rd Cross, Mcechs Layout<br />
                            Thanisandra, Rachenahalli<br />
                            Bengaluru, Karnataka, 560077<br />
                            India
                        </p>
                    </article>

                </div>
            </section>
        </div>
    )
}